// Module
var code = "<iframe id=\"creditCardListFrameElement\" ng-src=\"{{$ctrl.creditCardListURL}}\" frameborder=\"0\" scrolling=\"no\" width=\"100%\" height=\"100%\" iframe-list-onload=\"$ctrl.iframeloaded()\"></iframe>";
// Exports
module.exports = code;